module.exports = __webpack_public_path__ + "static/media/kia-off-app-provider-icon.213597bc.svg";